<template>
    <v-tooltip left>
        <template v-slot:activator="{ on }">
            <div class="contact-avatar clickable" v-on="on" :style="imageStyle" v-ripple>
                {{initials}}
            </div>
        </template>
        <div style="text-align:center">
            <img v-if="contact && contact.image && size < 35" :src="contact.image" style="width:40px;border-radius:50%">
            <div>{{fullName}}</div>
        </div>
    </v-tooltip>
</template>

<script>
import ContactHelpers from '@/helpers/ContactHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        contact: Object,
        emptyTooltip: {
            type: String,
            default: 'No Contact'
        } ,
        size: {
            type: Number,
            default: 50,
        },
    },

    computed: {
        pictureUrl() {
            try {
                return this.contact.image
            } catch (e) {
                return null
            }
        },
        backgroundUrlString() {
            if(this.pictureUrl && this.pictureUrl.indexOf('random') < 0)
                return `url('${this.pictureUrl}')`
            else
                return 'none'
        },
        initials() {
            if(!this.pictureUrl || this.pictureUrl.indexOf('random') > -1)
                return ContactHelpers.initials(this.contact)
            
        },
        fullName() {
            return ContactHelpers.fullName(this.contact) || this.emptyTooltip
        },
        imageStyle() {
            return {
                'background-image': this.backgroundUrlString,
                'width': this.size + 'px',
                'height': this.size + 'px',
                'max-width': this.size + 'px',
                'max-height': this.size + 'px',
                'min-width': this.size + 'px',
                'min-height': this.size + 'px',
                'line-height': this.size + 'px',
                'font-size': 6 + this.size / 5 + 'px',
                'font-weight': (this.size < 40 ? 600 : 400),
                'background-color': this.initialsToColour(this.initials),
            }
        }
    },

    methods: {
        initialsToColour(initials) {
            if(!initials || initials.length != 2)
                return '#b0bec5'

            const alphabet = "abcdefghijklmnopqrstuvwxyz"
            const colours = [
                '#e57373', '#f06292', '#ba68c8', '#9575cd', '#7986cb', '#039be5', '#ff5722'
            ]
            const pos1 = alphabet.indexOf(initials[0].toLowerCase())
            const pos2 = alphabet.indexOf(initials[1].toLowerCase())
            const colourPos = (pos1 + pos2) % 7
            return colours[colourPos]
        }
    },

    created() {

    }
}
</script>

<style scoped>

.contact-avatar {
    color: white;
    /* background-color: rgba(0,0,0,0.2); */
    background-size: cover;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    border:solid 1px white;
    font-weight: 600;
    display:inline-block;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4);
    transition: background-image .5s ease-in-out;
}
.contact-avatar:hover {
    background-color: rgba(0,0,0,0.3);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.8);
}
</style>




// WEBPACK FOOTER //
// ContactImage.vue?69557636